export default {
    driver_performance_events_info_name: "Evento",
    driver_performance_events_info_category: "Categoría",
    driver_performance_events_info_no_case_info: "No hay información del evento disponible.",
    driver_performance_events_info_risk: "Riesgo",
};